module.exports = "/assets/site/images/Rectangle 13.png?02136f42bd89f223ff2bd35499520e45";